<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre1" id="pgepubid00003"><a class="calibre3 pcalibre1 pcalibre2 pcalibre" id="PREFACE"></a><a class="calibre3 pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0002#toc">PREFACE.</a></h2>
<p class="calibre4"><a class="pcalibre1 pcalibre2 pcalibre" id="Page_5" title="[5]"></a> Some succeed while others fail. This is a recognized fact; yet history tells us that seven-tenths of our most successful men began life poor. As our title indicates, we shall endeavor to show "why some succeed while others fail." Knowing that everybody desires success, and recognizing the old adage, "Example is the best of teachers," we have selected representative characters from the multitude of successful men who have climbed the ladder of success, beginning at the bottom round. These we have followed from childhood to manhood, dwelling at length on the traits of character that have made them so rich and successful, believing that a careful study will convince all that the proverbial "luck" had little to do with it. On the contrary, one is taught those lessons of self-helpfulness and self-reliance which are so essential to success in life's struggles. It is fearful to think how many of our young people are drifting without an aim in life, and do not comprehend that they owe mankind their best efforts. We are all familiar with the parable of the slothful servant who buried his talent—all may profit by his example. To those who would succeed, we respectfully present this volume.</p>
<p class="calibre4"><a class="pcalibre1 pcalibre2 pcalibre" id="Page_6" title="[6]"></a></p>
<div class="blockquot">
<p class="calibre4"><i class="calibre5">Every young man is now a sower of seed on the field of life. The bright days of youth are the seed-time. Every thought of your intellect, every emotion of your heart, every word of your tongue, every principle you adopt, every act you perform, is a seed, whose good or evil fruit will prove bliss or bane of your after life.</i>—<span class="smcap1">Wise</span>.</p>
</div>
<p class="calibre4"><a class="pcalibre1 pcalibre2 pcalibre" id="Page_7" title="[7]"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?95bf2814